// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import DateRange from '../core/date-range';
import FormButtons from '../core/form-buttons';
import Input from '../core/input';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import Select from '../core/select';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchForm from '../app/services-search-form';
import ServicesSearchPanelAction from '../app/services-search-panel-action';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './audits.scss';

const servicesDataKey = 'audits';

class Audits extends Component {
    getColumnConfig() {
        return [
            {
                dataKey: 'correlationId',
                link: '/audits',
                linkKey: 'auditId',
                title: 'Correlation ID',
                type: 'link',
                width: '32%',
            },
            {
                dataKey: 'status',
                title: 'Status',
                width: '20%',
            },
            {
                dataKey: 'dateCreated',
                title: 'Date Created',
                type: 'date',
                width: '12%',
            },
            {
                dataKey: 'lastUpdated',
                title: 'Last Updated',
                type: 'date',
                width: '12%',
            },
            {
                dataKey: 'lastModifiedBy',
                title: 'Last Modified By',
                width: '24%',
            },
        ];
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxPages: 9,
            query,
            totalPages,
        };
    }

    getRowDetails() {
        return {
            whitelistKeys: [
                'auditId',
                'correlationId',
                'category',
                'statusCode',
                'rule',
                'reason',
                'dateCreated',
                'lastUpdated',
                'lastModifiedBy',
            ],
        };
    }

    getTablewithsortProps() {
        return {
            activeRowValueKey: 'routerParams.ruleId',
            columnConfig: this.getColumnConfig(),
            formName: servicesDataKey,
            rowDetails: this.getRowDetails(),
            servicesDataKey,
            updateOnUrlChange: false,
            ...this.props,
        };
    }

    renderForm = () => (
        <ServicesSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey}>
            <Input label="Correlation ID" name="correlationId" title="Use wildcard (*) for partial match" />
            <Select label="Category" name="category">
                <option value="">Filter by Category</option>
                <option value="IVI">IVI</option>
                <option value="EST">EST</option>
                <option value="ENRICH">Enrich</option>
                <option value="PRE_PROD">Pre Prod</option>
                <option value="AUTO_MAP">Auto Map</option>
                <option value="VALIDATION">Validation</option>
            </Select>
            <Select label="Status Code" name="statusCode">
                <option value="">Filter by Status Code</option>
                <option value="WARNING">Warning</option>
                <option value="ERROR">Error</option>
            </Select>
            <DateRange label="Created" name="dateCreated" />
            <DateRange label="Last Updated" name="lastUpdated" />
            <FormButtons />
        </ServicesSearchForm>
    );

    render() {
        const {searchData} = this.props;
        return (
            <div className="audits">
                <ServicesExportPanelAction searchData={searchData} />
                <ServicesSearchPanelAction contentRenderer={this.renderForm} />
                <SearchPagination {...this.getPaginationProps()} />
                <SearchTableWithSort {...this.getTablewithsortProps()} />
            </div>
        );
    }
}

Audits.propTypes = {
    query: PropTypes.object,
    searchData: PropTypes.array,
    totalPages: PropTypes.number,
};

export default withSearch(Audits, servicesDataKey);
